/* eslint-disable no-case-declarations */

import {
    ADMIN_PREFIX_SLASH,
    SERVER_WORKS_PREFIX,
} from './constants';

function isWorkModeEnabled () {
    return `${process.env.WORK_MODE}` !== 'false';
}

/**
 * Enforces "server works" maintenance mode.
 *
 * @param {object} ctx
 * @param {import('vue-router').RouteLocationNormalized} ctx.to
 * @returns {false|true|string} false to continue; true to allow; string path to redirect.
 */
export function ruleServerWorks ({ to }) {
    // console.log('🔍 серверные работы');
    const path = to.path;

    if (path.startsWith(SERVER_WORKS_PREFIX)) {
        if (!isWorkModeEnabled()) {
            return '/login';
        }

        return true;
    }

    if (!path.startsWith(ADMIN_PREFIX_SLASH) && isWorkModeEnabled()) {
        return SERVER_WORKS_PREFIX;
    }

    return false;
}
